"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = exports.createTransaction = void 0;
const bignumber_js_1 = require("bignumber.js");
const api_1 = require("./api");
const constants_1 = require("./constants");
const encode_1 = require("./encode");
const logic_1 = require("./logic");
/**
 * Create an empty t
 *
 * @returns {Transaction}
 */
const createTransaction = () => {
    return {
        family: "elrond",
        mode: "send",
        amount: new bignumber_js_1.BigNumber(0),
        recipient: "",
        useAllAmount: false,
        fees: new bignumber_js_1.BigNumber(50000),
        gasLimit: constants_1.MIN_GAS_LIMIT,
    };
};
exports.createTransaction = createTransaction;
/**
 * Prepare t before checking status
 *
 * @param {ElrondAccount} a
 * @param {Transaction} t
 */
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    const preparedTx = t;
    const tokenAccount = (t.subAccountId && a.subAccounts && a.subAccounts.find(ta => ta.id === t.subAccountId)) || null;
    if (tokenAccount) {
        preparedTx.data = encode_1.ElrondEncodeTransaction.ESDTTransfer(t, tokenAccount);
        preparedTx.gasLimit = constants_1.GAS.ESDT_TRANSFER;
    }
    else {
        switch (t.mode) {
            case "delegate":
                preparedTx.gasLimit = constants_1.GAS.DELEGATE;
                preparedTx.data = encode_1.ElrondEncodeTransaction.delegate();
                break;
            case "claimRewards":
                preparedTx.gasLimit = constants_1.GAS.CLAIM;
                preparedTx.data = encode_1.ElrondEncodeTransaction.claimRewards();
                break;
            case "withdraw":
                preparedTx.gasLimit = constants_1.GAS.DELEGATE;
                preparedTx.data = encode_1.ElrondEncodeTransaction.withdraw();
                break;
            case "reDelegateRewards":
                preparedTx.gasLimit = constants_1.GAS.DELEGATE;
                preparedTx.data = encode_1.ElrondEncodeTransaction.reDelegateRewards();
                break;
            case "unDelegate":
                preparedTx.gasLimit = constants_1.GAS.DELEGATE;
                preparedTx.data = encode_1.ElrondEncodeTransaction.unDelegate(t);
                break;
            case "send":
                break;
            default:
                throw new Error("Unsupported transaction mode: " + t.mode);
        }
    }
    if (t.useAllAmount) {
        // Set the max amount
        preparedTx.amount = tokenAccount ? tokenAccount.balance : a.spendableBalance;
        // Compute estimated fees for that amount
        preparedTx.fees = yield (0, api_1.getFees)(preparedTx);
        // Adjust max amount according to computed fees
        if (!tokenAccount && (0, logic_1.isAmountSpentFromBalance)(t.mode)) {
            preparedTx.amount = preparedTx.amount.gt(preparedTx.fees)
                ? preparedTx.amount.minus(preparedTx.fees)
                : new bignumber_js_1.BigNumber(0);
        }
    }
    else {
        preparedTx.fees = yield (0, api_1.getFees)(preparedTx);
    }
    return preparedTx;
});
exports.prepareTransaction = prepareTransaction;
//# sourceMappingURL=js-transaction.js.map